(() => {
 const initialize = async (scope = document) => {
  await customElements.whenDefined('ks-product');
  scope.querySelectorAll('.ks-racks-head').forEach(head => {
   if (head.dataset.ksRacksReady) return;
   const product = head.querySelector('ks-product');
   if (!product?.data) return;
   head.dataset.ksRacksReady = 'true';
   const media = JSON.parse(head.querySelector('[data-ks-racks-media]')?.textContent || '[]');
   media.forEach(pair => {
    const variant = product.data.variants.find(v => String(v.id) === pair.variant);
    if (variant) variant.mediaId = pair.media;
   });
   const addon = head.querySelector('[data-ks-rack-addon]');
   const update = variant => {
    if (!addon) return;
    addon.hidden = variant.title.toLowerCase() !== 'rack';
    if (addon.hidden) {
     const checkbox = addon.querySelector('[data-ks-addon]');
     if (checkbox) checkbox.checked = false;
    }
   };
   product.addEventListener('variant:change', event => update(event.detail.variant));
   update(product.variant);
   const selected = media.find(pair => pair.variant === String(product.variant.id));
   if (selected) requestAnimationFrame(() => product.goToMedia(selected.media, 'instant'));
  });
  scope.querySelectorAll('.ks-racks-story .torii-faq-question').forEach((button, index) => {
   const answer = button.nextElementSibling;
   if (!answer) return;
   button.type = 'button';
   answer.id ||= `KsRacksFaq-${index}`;
   button.setAttribute('aria-controls', answer.id);
   const sync = () => button.closest('.torii-faq-list')?.querySelectorAll('.torii-faq-question').forEach(item => {
    item.setAttribute('aria-expanded', String(item.parentElement.classList.contains('torii-faq-open')));
   });
   sync();
   if (button.dataset.ksRacksReady) return;
   button.dataset.ksRacksReady = 'true';
   button.addEventListener('click', () => queueMicrotask(sync));
  });
  scope.querySelectorAll('.ks-racks-story .torii-video-placeholder').forEach(control => {
   if (control.dataset.ksRacksReady) return;
   control.dataset.ksRacksReady = 'true';
   control.setAttribute('role', 'button');
   control.setAttribute('tabindex', '0');
   control.setAttribute('aria-label', control.closest('.torii-video-section')?.querySelector('.torii-video-caption')?.textContent || document.title);
   control.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); control.click(); }
   });
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
 else initialize();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
